<template>
    <!-- 
      TODO: implement hand scanning
      * Test this through using the scanner and a generated barcode from the samples list
      * All scanning should do is search for the scanned id of the sample. 
      * once the sample is found
        * Get the sample collection
        * add the project connection
        * add the customer connection
        * add to the received list
    -->
    <div class="print-hidden">
        <div v-if="!scanning">
            <b-button variant="primary" block size="lg"><b>Focus on this page to begin scanning...</b></b-button>
            <div class="my-1"></div>
        </div>
        <div v-if="scanning">
            <b-card>
                <b-alert v-if="scan_error" variant="warning" show>{{
                    scan_error
                }}</b-alert>
                <b-button v-for="(scan_item, index) in scan_list" :key="index" class="bg-transparent text-left" block>
                    <b-badge pill :variant="scan_item.status === 'Received' ? 'success' : 'info'" class="mr-1">{{
                        scan_item.status }}</b-badge>
                    {{ scan_item.formatted_pid }}
                    {{ scan_item.sample ? scan_item.sample.receiving_id : null }}
                </b-button>
                <b-button class="bg-transparent" block>
                    <i class="fa fa-spin fa-spinner"></i> Waiting for your next scan...
                    {{ scanned ? "(Last Scan: " + scanned + ")" : null }}
                </b-button>
            </b-card>
        </div>
    </div>
</template>
<script>
import SampleCollection from '@/collections/lab/SampleCollection';

export default {
    name: "ReveiveScanner",
    data() {
        return {
            scanning: false,
            scan_error: null,
            scanned: null,
            scanned_sanitized: null,
            scan_list: [],
        };
    },
    methods: {
        onBarcodeScanned(barcode) {
            this.scanned = barcode;
            let matches = barcode.match(/SA-(\d{6})/g);
            if (!matches || !matches.length) {
                this.scan_error = "Scan does not match the pattern SA-XXXXXX.";
                return false;
            }
            this.addScanItem({
                code: barcode,
                pid: barcode.match(/\d+/g).map(Number),
                formatted_pid:
                    "SA-" + barcode.match(/\d+/g).map(Number).toString().padStart(6, "0"),
                sample: null,
                status: null,
            });
        },
        clickReceived(sample) {
            this.addScanItem({
                code: null,
                pid: +sample.get("pid"),
                formatted_pid: sample.publicNumber(),
                sample: sample,
                status: null,
            });
        },
        addScanItem(item) {
            this.scan_error = null;
            this.scan_list.forEach((scan_item) => {
                if (
                    (item.code && scan_item.code === item.code) ||
                    scan_item.pid === item.pid
                ) {
                    this.scan_error = "This item has already been scanned";
                }
            });
            if (this.scan_error) {
                return false;
            }
            item.status = "Receiving";
            if (!item.sample) {
                let collection = new SampleCollection();
                collection.getFilter().filterEquals("pid", item.pid);
                collection.fetch().then(() => {
                    let sample = collection.models[0];
                    if (sample) {
                        item.sample = sample;
                        this.updateSampleStatus(item.sample).then(() => {
                            item.status = "Received";
                        });
                    }
                });
            } else {
                this.updateSampleStatus(item.sample).then(() => {
                    item.status = "Received";
                });
            }
            this.scan_list.push(item);
            return item;
        },
    },
    created() {
        setInterval(() => {
            if (document.hasFocus()) {
                this.scanning = true;
                this.$barcodeScanner.init(this.onBarcodeScanned);
            } else {
                this.scanning = false;
                this.$barcodeScanner.destroy();
            }
        }, 300);
    },
}
</script>